import script from "./MailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MailPage.vue?vue&type=script&setup=true&lang=js"

import "./MailPage.vue?vue&type=style&index=0&id=4b46ce15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b46ce15"]])

export default __exports__